import React, {useEffect, useState} from "react";
import IconButton from "react-rte/lib/ui/IconButton";
import queryString from 'query-string';
import {validatePassword} from "../../Functions/FunctionsPassword";
import {Button, InputAdornment, OutlinedInput} from "@mui/material";
import {IoMdEye, IoMdEyeOff} from "react-icons/io";
import FunctionsData from "../../../src/Functions/FunctionsData";


/*
* This page is used to reset the password of a user.
* The user receives a link in his email, which contains a token.
* The token is used to validate the user.
 */
export default function Recovery() {

	let params = queryString.parse(window.location.search);
	const [sent,setSent] = useState(false);
	const [pressed,setPressed] = useState(false);
	const [showPassword,setShowPassword] = useState(false);
	const [password,setPassword] = useState('');
	const [passwordRepeat,setPasswordRepeat] = useState('');
	const [valid,setValid] = useState(false);
	const [error,setError] = useState(false);


	useEffect(() => {
		setValid((password === passwordRepeat) && validatePassword(password) === true)
	}, [password,passwordRepeat])

	useEffect(() => {
		const headers = {
			method:'post',
			headers:{'Content-Type': 'application/json'},
			body:JSON.stringify({token:params.cid})
		}

		fetch(FunctionsData.getApiUrl('/api/search/vet/validate'), headers)
			.then ((r) => r.json())
			.then ((res) => {
				// console.log(res, res.error,(res.error === true))
				if(res.error === true) {
					setError(true);
				}
			})

	}, [])

	/*
	* This function is used to set the new password.
	 */
	function setNewPassword() {

		const headers = {
			method:'post',
			headers:{'Content-Type': 'application/json'},
			body:JSON.stringify({password:password,token:params.cid})
		}

		fetch(FunctionsData.getApiUrl('/api/search/vet/reset'), headers)
			.then ((r) => r.json())
			.then ((res) => {
				// console.log(res);
				setSent(true);
			})

	}

	if (error === true) return (
		<div className={"login-parent"} style={{textAlign:'center',verticalAlign: 'middle', height:'100vh', width:'100%'}}>
			<div style={{width:300, marginTop:300, marginLeft:'calc(50% - 150px)'}}>
				<div>
					The link is  not valid or expired. Please request a new link at {window.location.protocol}//{window.location.host}.
				</div>
			</div>
			<div style={{marginTop:20}}>
				<a href={"#"} onClick={(e) => {
					e.preventDefault();
					window.location.href = window.location.protocol + "//" + window.location.host;
				}}>Back to the login page</a>
			</div>
		</div>
	)

	return (
		<div className={"login-parent"} style={{textAlign:'center',verticalAlign: 'middle', height:'100vh', width:'100%'}}>

			<div style={{width:300, marginTop:300, marginLeft:'calc(50% - 150px)'}}>
				{
					(sent === false) ?
						<>


							<h5 style={{width:'100%',marginTop:20}}>Your new password</h5>
							<OutlinedInput
								style={{width:'100%'}}
								id="outlined-adornment-password"
								type={showPassword ? 'text' : 'password'}
								value={password}
								error={!validatePassword(password)}
								onChange={(e) => setPassword(e.target.value)}
								endAdornment={
									<InputAdornment position="end">
										<IconButton
											aria-label="toggle password visibility"
											onClick={() => setShowPassword(!showPassword)}
											edge="end"
										>
											{showPassword ? <IoMdEye /> : <IoMdEyeOff />}
										</IconButton>
									</InputAdornment>
								}
							/>
							<small>Minimum 8 characters, requires lower and upper case characters as well as numbers</small>

							<h5 style={{width:'100%',marginTop:20}}>Repeat your password</h5>
							<OutlinedInput
								style={{width:'100%'}}
								value={passwordRepeat}
								type={"password"}
								onChange={(e) => setPasswordRepeat(e.target.value)}
							/>

							<Button variant={"contained"} disabled={pressed || !valid} className="btn-main-login" style={{width: '100%', marginTop:20}} type="submit" onClick={() => {
								setPressed(true);
								setNewPassword();
							}
							}>
								Set your new password.
							</Button>
						</>
						:
						<div>
							That's all done, you can now return to the login page.
						</div>
				}

			</div>
			<div style={{marginTop:20}}>
				<a href={"#"} onClick={(e) => {
					e.preventDefault();
					// console.log( window.location.protocol + "//" + window.location.host);
					window.location.href = window.location.protocol + "//" + window.location.host;
				}}>Back to the login page</a>
			</div>
		</div>
	)

}
